import React, { ReactNode, useEffect, useRef, useState } from "react";
import "./ChatTab.scss";
import { ChatBalloon } from "./ChatBalloon/ChatBalloon";
import { Button } from "../../../../../components/Button/Button";
import { useGameState } from "../../../../../hooks/useGameState";
import { useTranslation } from "react-i18next";

interface IProps {

}

interface IMessage {
    type: 'received' | 'sent',
    message: string | ReactNode,
    largeMessage?: boolean,
}


export function ChatTab(props: IProps) {
    const { i18n, t } = useTranslation();
    const { language } = i18n;
    const messagesCollection: {[key: string]: IMessage[]} = {
        en: [{
            type: 'received',
            message: 'Are you available?'
        }, {
            type: 'sent',
            message: 'Yes',
        }, {
            type: 'received',
            message: 'Five tests must be carried out urgently to recognize the correct identity of this virus to make an life saving recipe afterward.',
            largeMessage: true,
        }, {
            type: 'sent',
            message: 'Right',
        }, {
            type: 'received',
            message: 'Always make sure you choose well',
        }, {
            type: 'received',
            message: 'Accuracy is most certainly required.',
        }, {
            type: 'sent',
            message: 'I take this job!',
        }, {
            type: 'received',
            message: <>This is schematic of structure where we looking for:</>,
        }, {
            type: 'received',
            message: 'By dragging and dropping the blocks under each other, you can make the right combination using the addition and subtraction of the lines.',
            largeMessage: true,
        }, {
            type: 'sent',
            message: 'Right',
        }, {
            type: 'received',
            message: 'We have trust in you - Good luck!',
        }],
        nl: [{
            type: 'received',
            message: 'Ben je beschikbaar?'
        }, {
            type: 'sent',
            message: 'Ja',
        }, {
            type: 'received',
            message: 'Vijf tests moeten met spoed worden uitgevoerd om de identiteit van het virus vast te stellen, zodat een levensreddend recept kan worden gemaakt.',
            largeMessage: true,
        }, {
            type: 'sent',
            message: 'Oké',
        }, {
            type: 'received',
            message: 'Belangrijk dus om de juiste opties te kiezen.',
        }, {
            type: 'received',
            message: 'Nauwkeurigheid is van het hoogste belang.',
        }, {
            type: 'sent',
            message: 'Ik neem deze opdracht!',
        }, {
            type: 'received',
            message: 'Goed, Uit het laboratorium ontvangen we de schematisch weergave van de virus.',
        }, {
            type: 'received',
            message: 'We hebben losse structuur samples. Selecteer de juiste samples of zorg voor de juiste combinatie om het de virus te herkennen. Het is net als rekenen met optellen en aftrekken.',
            largeMessage: true,
        }, {
            type: 'sent',
            message: 'Juist',
        }, {
            type: 'received',
            message: 'We hebben vertrouwen in je. Veel succes!',
        }]
    };
    const messages = messagesCollection[language];

    const ref = useRef<HTMLDivElement>(null);
    const { gameState, setGameState } = useGameState();
    const [receivedMessages, setReceivedMessages] = useState<IMessage[]>([]);
    const [showButton, setShowButton] = useState(false);
    const [autoScroll, setAutoScroll] = useState(true);
    const [goFast, setGoFast] = useState(false);
    const showBalloons = gameState === 'tutorial';

    const receivedAllMessages = receivedMessages.length === messages.length;

    // Reset all when things are gone
    useEffect(() => {
        if (gameState !== 'playing' && gameState !== 'level-tutorial') {
            return () => {
                setGoFast(false);
                setShowButton(false);
                setAutoScroll(true);
                setReceivedMessages([]);
            }
        }
    }, [gameState])

    // Time in seconds it takes for a message to pop up
    useEffect(() => {
        if (showBalloons && receivedMessages.length === 1) {
            setTimeout(() => {
                setShowButton(true);
            }, 5000);
        }
        const receivedAllMessages = receivedMessages.length === messages.length;
        if (showBalloons && !receivedAllMessages) {
            const newMessage = messages[receivedMessages.length];
            const prevMessage = messages[receivedMessages.length - 1];
            const delay = goFast ? 250 : (receivedMessages.length === 0 ? 0 : (prevMessage?.largeMessage ? 3000 : 2000));
            const timeout = setTimeout(() => {
                setReceivedMessages((prevState) => {
                    return [
                        ...prevState,
                        newMessage
                    ]
                });
            }, delay);
            return () => {
                clearTimeout(timeout);
            }
        }
    }, [gameState, showBalloons, messages, goFast, receivedMessages]);

    useEffect(() => {
        if (!ref.current) return;
        if (!showBalloons) return;
        const div = ref.current;
        if (autoScroll) {
            div.scroll({
                top: Math.max(0, div.scrollHeight - div.offsetHeight),
                behavior: 'smooth',
            })
        }
    }, [showBalloons, receivedMessages, autoScroll, ref]);

    // Stop autoScrolling on touch
    useEffect(() => {
        if (!ref.current) return;
        if (!showBalloons) return;
        const div = ref.current;
        const handleStopAutoScrolling = () => {
            setAutoScroll(false);
        }
        div.addEventListener('pointerdown', handleStopAutoScrolling);
        return () => {
            div.removeEventListener('pointerdown', handleStopAutoScrolling);
        }
    }, [showBalloons, ref]);

    return (
        <div className="chat-tab-wrapper">
            <div className="conversation" ref={ref}>
                {showBalloons ? receivedMessages.map(({ type, message, largeMessage }, index) => {
                    return <ChatBalloon key={index} type={type} largeMessage={largeMessage}>{message}</ChatBalloon>
                }) : null}
            </div>
            <div className={`button-bar ${!showButton ? 'hidden' : ''}`}>
                {receivedAllMessages ? (
                    <Button variant={"major-alpha"} icon={"arrow-right"} onClick={() => setGameState('level-tutorial')}>
                        {t('game.button-lets-start')}
                    </Button>
                ) : (
                    <Button variant={"major-alpha"} icon={"arrow-right"} onClick={() => setGoFast(true)}>
                        {t('game.button-skip')}
                    </Button>
                )}
            </div>
        </div>
    )
}
